import { createEvent, restore, sample } from "effector";
import { persist } from "effector-storage/local";

export const setCurrentLocale = createEvent<string>();
export const $currentLocale = restore(setCurrentLocale, "");
export const setDefaultLocale = createEvent<string>();

persist({ key: "kex-locale", store: $currentLocale });

sample({
  clock: setDefaultLocale,
  fn: (source, clock) => {
    if (!source) {
      return clock;
    }
    return source;
  },
  source: $currentLocale,
  target: $currentLocale,
});
